import React from "react";

const NotFound: React.FC = () => (<div className="font-semibold text-lg p-4">Trang này không tồn tại!</div>);

export default NotFound;